/**************************************************
 * Nombre:       Seccion_Profesional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Profesional_Detalle from "./Componentes/Profesional_Detalle";
import Profesional_Registro_Educacion from "./Componentes/Profesional_Registro_Educacion";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Profesional = () => {

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Profesional_Detalle/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Profesional_Registro_Educacion/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Profesional